import { Injectable } from '@angular/core';
import { FeedItem } from '@model';
import { select, Store } from '@ngrx/store';
import { SubSink } from 'subsink';
import * as fromConfigurationStore from '@appStore/configuration';
import { filter, map, Observable, of, take, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
// import * as Parser from 'rss-parser';
import Parser from '../../../node_modules/rss-parser/dist/rss-parser.min';

/** A router wrapper, adding extra functions. */
@Injectable()
export class SxFeedService {

  // --- Not used anymore - RSS Feed is fetched from Backend ---

  // feedItemList: FeedItem[] = [];
  // private subs = new SubSink();
  // private cors = '';
  // private feedUrl = '';
 
  // constructor(
  //   private http: HttpClient,
  //   private configurationStore: Store<fromConfigurationStore.State> ) {

  //   this.subs.sink = this.configurationStore
  //     .pipe(select(fromConfigurationStore.getApiConfiguration))
  //     .pipe(
  //       filter(x => !!x),
  //       take(1)
  //     )
  //     .subscribe(x => {
  //       this.feedUrl = x.sxNewsFeedUrl;
  //     });
  // }

  // getNewsFeed(): Observable<any> {

  //   return this.http.get(this.cors + this.feedUrl, { responseType: 'text' })
  //     .pipe(
  //       map(xml => this.extractFeedList(xml)),
  //       catchError(this.handlerError)
  //     );
  // }

  // handlerError = (error: Response, caught: Observable<any>) => {
  //   let errorMsg = '';
  //     if (error instanceof Response) {
  //       const err = error || '';
  //       errorMsg = `${error.status} - ${error.statusText || ''} ${err}`;
  //     } else {
  //       errorMsg = error;
  //     }
  //     console.log(errorMsg);
  //     window.alert(errorMsg);
  //     return throwError(errorMsg);
  // }

  // extractFeedList(xml: any) {
  //   let parser = new Parser({
  //     customFields: {
  //       item: ['article-img']
  //     }
  //   });

  //   const ZoneAwarePromise: any = parser.parseString(xml);
  //   // Get list of feed items
  //   const FeedItemList = ZoneAwarePromise.__zone_symbol__value.items;

  //   const itemsArray = [];
  //   if (FeedItemList.length) {
  //     FeedItemList.forEach((feedItem: any) => {
  //       let content = feedItem['content:encoded'] || feedItem.content;
  //       let thumbNail = feedItem['article-img'];

  //       let obj = {
  //         'title': feedItem.title,
  //         'link': feedItem.link,
  //         'author': feedItem['dc:creator'] || feedItem.author,
  //         'pubDate': feedItem.pubDate,
  //         'content': content,
  //         'thumbnail': thumbNail
  //       };

  //       itemsArray.push(new FeedItem(obj));
  //     });
  //   } else {
  //     return of([]);
  //   }
  //   return itemsArray;
  // }
}
